export default "__VITE_ASSET__b8ecf0fa__"